import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";
import FrontBusiness from "@/business/FrontBusiness";
import VueBusiness from "@/business/VueBusiness";

const path = 'api/tipo-servico';

export default  {

  dificuldades : Object.freeze([
    {id: 'MUITO_LEVE', nome: '1 - Muito Leve'},
    {id: 'LEVE', nome: '2 - Leve'},
    {id: 'MODERADO', nome: '3 - Moderado'},
    {id: 'EXIGENTE', nome: '4 - Exigente'},
    {id: 'MUITO_EXIGENTE', nome: '5 - Muito exigente'},
    {id: 'DESAFIADOR', nome: '6 - Desafiador'},
    {id: 'MUITO_DESAFIADOR', nome: '7 - Muito desafiador'},
  ]),

  parseOpcoes(opcoes) {
    if (!opcoes) return {}
    if (typeof opcoes  === 'string') {
      opcoes = JSON.parse(opcoes);
    }
    opcoes.tipoTransacaoDoi = opcoes?.tipoTransacaoDoi || 'NENHUM'
    return opcoes;
  },

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getSimpleListIds(ids){
    return Http.post(`${path}/simple`, ids);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async getByDominio(id, resetCache = ''){
    return Http.get(`${path}/dominio/${id}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getByDominioSimples(dominio){
    return Http.get(`${path}/dominio-simples/${dominio}`).then(l => l.map(i => {
      i.opcoes = this.parseOpcoes(i.opcoes);
      return i;
    }));
  },

  async getByDominioSimplesIds(dominio, ids){
    return Http.post(`${path}/dominio-simples/${dominio}`, ids).then(l => l.map(i => {
      i.opcoes = this.parseOpcoes(i.opcoes);
      return i;
    }));
  },

  async getByDominioLivroSimples(id, livro){
    return Http.get(`${path}/dominio-livro-simples/${id}/${livro}`).then(l => l.map(i => {
      i.opcoes = this.parseOpcoes(i.opcoes);
      return i;
    }));
  },

  async getByDominioSimplesNotasPorTipoDeAto(id, tipoAto){
    return Http.get(`${path}/dominio-notas-simples/${id}/${tipoAto}`).then(l => l.map(i => {
      i.opcoes = this.parseOpcoes(i.opcoes);
      return i;
    }));
  },

  async getByDominioSimplesTodos(id){
    return Http.get(`${path}/dominio-simples-todos/${id}`).then(l => l.map(i => {
      i.opcoes = this.parseOpcoes(i.opcoes);
      return i;
    }));
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async lote(request){
    return Http.post(`${path}/lote`, request);
  },

  async getTiposCustaApuracao() {
    return Http.get(`${path}/tribunal/tipo-custa-apuracao`);
  },

  async getTiposCobrancaTribunal(dominio = ''){
    return Http.get(`${path}/tribunal/tipo-cobranca/${dominio}`);
  },

  async importar(id, base){
    return Http.get(`${path}/importar/${id}/${base}`);
  },

  async getTiposAtoTribunal(dominio = ''){
    return Http.get(`${path}/tribunal/tipo-ato/${dominio}`);
  },

  async getTiposAtoTribunalTratado(item, dominio) {
    let tiposTribunal = await this.getTiposAtoTribunal(dominio);
    item.codigoTj = (((tiposTribunal || []).find(e => e.id === item?.tipoServico?.tipoTribunal))?.codigo) || '';
    item.codigoTj = item.codigoTj + '';

    tiposTribunal = tiposTribunal.map(t => {
      return {id: t.codigo + '', nome: t.nome}
    });

    return {
      tiposTribunal,
      item
    }
  },
  async getTiposInformacaoVerbal(){
    return Http.get(`${path}/tribunal/tipo-informacao-verbal`);
  },

  async getCategoriaAto(dominio){
    return Http.get(`${path}/categoria-ato/${dominio}`);
  },

  async exibirMensagemConfirmacaoTipoTribunal(referencia, tipo, dto) {
    if (!VueBusiness.getVueRoot().isEstadoSP) return;
    if(dto.selado && referencia){
      let verificacao = await this.verificarTipoTribunal(referencia, tipo);
      if (verificacao.divergente) {
        let confirmou = await FrontBusiness.openConfirmacao(
          'Atenção! O Tipo de Registro/Averbação [Tribunal] deste item foi alterado e está divergente da classificação utilizada na selagem atual. Para manter a integridade dos livros e relatórios, será necessário realizar a retificação do selo correspondente.',
          'Deseja continuar?'
        ).catch(() => false);
        if(confirmou !== 'confirm') {
          throw 'Ação cancelada pelo usuário';
        }
      }
    }
  },

  async verificarTipoTribunal(referencia, tipo) {
    return Http.get(`${path}/${referencia}/verificar-tipo-tribunal/${tipo}`);
  },
}
